import { Upload } from 'lucide-react';

const VideoContainer = ({ 
  videoRef, 
  canvasRef, 
  mode, 
  capturedImage, 
  flash, 
  overlayText, 
  uploadText, 
  capturedText,
  showOverlay = true,
  mirrored = false 
}) => (
  <div className="video-container relative">
    {!capturedImage ? (
      <>
        {mode === 'camera' ? (
          <>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              className="w-full h-auto"
              style={mirrored ? { transform: 'scaleX(-1)' } : {}}
            />
            
            {/* Flash Effect */}
            {flash && (
              <div className="absolute inset-0 bg-white opacity-80 animate-pulse"></div>
            )}
            
            {/* Overlay */}
            {showOverlay && (
              <div className="absolute inset-0 pointer-events-none">
                <div className="absolute inset-8 border-4 border-dashed border-primary rounded-lg"></div>
                <div className="absolute top-4 left-4 right-4 text-center">
                  <span className="bg-black/50 text-white px-4 py-2 rounded text-sm">
                    {overlayText}
                  </span>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="video-container flex items-center justify-center bg-gray-100 min-h-[300px] gap-3">
            <Upload size={48} />
            <p className="text-gray-600">{uploadText}</p>
          </div>
        )}
        
        <canvas ref={canvasRef} className="hidden" />
      </>
    ) : (
      <div className="video-container">
        <img
          src={capturedImage}
          alt="Captured"
          className="w-full h-auto"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-green-500/30">
          <div className="bg-white text-green-600 px-6 py-3 rounded-lg font-bold text-xl">
            {capturedText}
          </div>
        </div>
      </div>
    )}
  </div>
);

export default VideoContainer;
